import { CheckIcon, CopyIcon, MapPinIcon } from "@phosphor-icons/react";
import { useIntl } from "react-intl";

import { CollapsibleCard } from "@/components/CollapsibleCard/CollapsibleCard";
import { IconButton } from "@/components/IconButton/IconButton";
import { HotelMap } from "@/features/hotels/components/hotel/HotelMap";
import type { HotelData } from "@/features/hotels/types/types";
import { useCopyToClipboard } from "@/hooks/useCopyToClipboard";

interface HotelLocationCardProps {
  hotel: HotelData;
}

export const HotelLocationCard = ({ hotel }: HotelLocationCardProps) => {
  const intl = useIntl();
  const { copied, copyText } = useCopyToClipboard();

  if (!hotel.geolocation && !hotel.address) return null;

  return (
    <CollapsibleCard
      title={intl.formatMessage({
        defaultMessage: "Location",
        description: "Hotel's location card title",
      })}
      collapsible={false}
    >
      <HotelMap hotel={hotel} />

      {hotel.address && (
        <div className="mt-4 flex items-center gap-1">
          <MapPinIcon size={16} className="shrink-0 text-text-primary" />
          <p className="text-sm text-text-primary">{hotel.address}</p>
          <IconButton
            color="interactive"
            size="small"
            disabled={copied}
            onClick={() => copyText(hotel.address)}
            aria-label={intl.formatMessage({
              defaultMessage: "Copy address",
              description: "Button to copy the hotel address to clipboard",
            })}
          >
            {copied ? <CheckIcon size={16} /> : <CopyIcon size={16} />}
          </IconButton>
        </div>
      )}
    </CollapsibleCard>
  );
};
